module.exports = __webpack_public_path__ + "img/yesh_no.f1bf8f04.png";